import { render, staticRenderFns } from "./importPupil.vue?vue&type=template&id=3d225004&"
import script from "./importPupil.vue?vue&type=script&lang=js&"
export * from "./importPupil.vue?vue&type=script&lang=js&"
import style0 from "./importPupil.vue?vue&type=style&index=0&id=3d225004&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports